import React, { useState, useRef, useEffect } from 'react'
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import { alpha } from '@mui/material/styles';
import "./style.scss"
import { useDispatch, useSelector } from 'react-redux'
import {
  setCampaignABTestVariation,
  setCampaignABTestPercentage,
  setCampaignABTestWaitTime,
  setCampaignABTestDecidingParameter
} from 'ReduxStore/Slices/campaignSlice'

export default function CampaignABTest() {
  const dispatch = useDispatch()
  const { campaingABTestData, campaignEditMode, campaignId, campaignViewMode } = useSelector(state => state.campaignSetter)
  const abTestVariationRef = useRef()
  const abTestWaitTimeRef = useRef()
  const abTestDecidingParameterRef = useRef()

  useEffect(() => {
    abTestVariationRef.current.value = campaingABTestData.campaignABTestVariation
    abTestWaitTimeRef.current.value = campaingABTestData.campaignABTestWaitTime
    abTestDecidingParameterRef.current.value = campaingABTestData.campaignABTestDecidingParameter
  }, [campaingABTestData.campaignABTestPercentage])

  useEffect(() => {
    if (campaingABTestData.campaignABTestVariation === "Schedule") {
      dispatch(setCampaignABTestPercentage(100))
    }
  }, [campaingABTestData.campaignABTestVariation])

  const handleChange = (e) => {
    const value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    dispatch(setCampaignABTestWaitTime(value))
  };

  return (
    <div className='container-fluid abtestOutter'>
      <div className='abTestWrapper'>
        <div>
          <label className="large">
            Variation
          </label>
          <div>
            <select
              id="selectSubscribtion"
              className="kwDesign2 w486"
              onChange={(e) => {
                dispatch(setCampaignABTestVariation(e.target.value))
                if (e.target.value === "Schedule") {
                  dispatch(setCampaignABTestPercentage(100))
                } else if (e.target.value === "Content" || e.target.value === "Subject") {
                  dispatch(setCampaignABTestPercentage(10))
                }
              }}
              ref={abTestVariationRef}
              disabled={(campaignEditMode || campaignId !== "") ? true : false}
            >
              <option value="">Select</option>
              <option value="Subject">Subject</option>
              <option value="Content">Design</option>
              <option value="Schedule">Schedule</option>

            </select>
          </div>
        </div>
        <div>
          <label className="large">
            Percentage
          </label>
          <Box width={300}>
            <Slider aria-label="Default" valueLabelDisplay="auto" sx={{
              color: '#2C40CE',
              height: '10px',
              '& .MuiSlider-thumb': {
                '&:hover, &.Mui-focusVisible': {
                  boxShadow: `0px 0px 0px 0px ${alpha('#ECEFFF', 0.5)}`,
                },
                '&.Mui-active': {
                  boxShadow: `0px 0px 0px 0px ${alpha('#ECEFFF', 0.5)}`,
                },
              },
            }}
              onChange={(e) => { dispatch(setCampaignABTestPercentage(e.target.value)) }}
              min={(campaingABTestData.campaignABTestVariation === "Subject" || campaingABTestData.campaignABTestVariation === "Content") && 10}
              max={(campaingABTestData.campaignABTestVariation === "Subject" || campaingABTestData.campaignABTestVariation === "Content") ? 40 : 100}
              value={campaingABTestData.campaignABTestPercentage}
              disabled={(campaingABTestData.campaignABTestVariation == "Schedule" || campaingABTestData.campaignABTestVariation == "") || campaignViewMode ? true : false}
            />
          </Box>
        </div>

        <div>
          <label className="large">
            Deciding Parameter
          </label>
          <div>
            <select
              id="selectSubscribtion"
              className="kwDesign2 w486"
              onChange={(e) => {
                dispatch(setCampaignABTestDecidingParameter(e.target.value))
              }}
              ref={abTestDecidingParameterRef}
              disabled={campaignViewMode}
            >
              <option value="">Select</option>
              <option value="Open">Open</option>
              <option value="Click">Click</option>
              <option value="OpenAndClick">Open & Click</option>

            </select>
          </div>
        </div>
        <div >
          <label className="large">
            Wait Time (Hrs)
          </label>
          <div>
            <input
              type="text"
              className="kwDesign"
              required
              pattern="^\d+(?:\.\d{1,2})?$"
              ref={abTestWaitTimeRef}
              value={campaingABTestData.campaignABTestWaitTime}
              onChange={handleChange}
              disabled={campaignViewMode}
            />
          </div>

        </div>
      </div>


    </div>
  )
}
